<template>
  <b-card
    title="مدیریت صورتحساب ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="addInvoice()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="درمانگاه"
                  label-for="ClinicId"
                >
                  <z-clinic
                    v-model="filterOptions.ClinicId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              :to="{ name: 'updateinvoice', params: { id: data.value }}"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Date)="data">
            {{ data.value | date }}
          </template>

          <template #cell(Clinic)="data">
            <b-badge
              variant="info"
            >
              {{ data.value.Title }}
            </b-badge>
          </template>

          <template #cell(Balance)="data">
            <span style="direction: ltr; display: inline-block;">{{ data.value | price }}</span>
          </template>

          <template #cell(Price)="data">
            <span style="direction: ltr; display: inline-block;">{{ data.value | price }}</span>
          </template>

          <template #cell(Debt)="data">
            <span style="direction: ltr; display: inline-block;">{{ data.value | price }}</span>
          </template>

          <template #cell(TotalPrice)="data">
            <b-badge variant="light-primary" v-if="(data.item.Price!= null)&&(data.item.Debt!= null)" style="direction: ltr; display: inline-block;">{{ (data.item.Price + data.item.Debt) | price }}</b-badge>
          </template>

          <template #cell(IsConfirm)="data">
            <b-badge
              :variant="data.value ? 'light-success' : 'light-secondary'"
              @click="confirm(data.item)"
            >
              {{ data.value ? 'تایید شده' : 'تایید نشده' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
                            <b-link :to="{ name: 'updateinvoice', params: { id: data.item.Id }}">
                              <feather-icon
                                :id="`invoice-row-${data.item.Id}-send-icon`"
                                icon="EditIcon"
                                size="16"
                                class="mr-1"
                              />
                            </b-link>

              <b-link
                :href="getBaseUrl()+'?id='+data.item.Id"
                target="_blank"
              >
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="PrinterIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showInvoiceModal"
      v-model="showInvoiceModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات صورتحساب"
      :no-close-on-backdrop="true"
      size="md"
      @ok="save"
    >
      <b-row>

        <b-col md="6">
          <b-form-group
            label="درمانگاه"
            label-for="ClinicId"
          >
            <z-clinic v-model="row.ClinicId" />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="تاریخ"
            label-for="Date"
          >
            <date-picker
              v-model="row.Date"
              placeholder=""
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              id="Description"
              v-model="row.Description"
              name="Description"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if="showConfirmModal"
      v-model="showConfirmModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      modal-class="confirm-pay-modal"
      title="وضعیت صورتحساب"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="confirmInvoice"
    >
      <div v-if="confirmRow.IsConfirm">
        وضعیت صورتحساب مورد نظر به تایید نشده تغییر نمایید؟
      </div>
      <div v-else>
        وضعیت صورتحساب مورد نظر به تایید شده تغییر نمایید؟
      </div>
    </b-modal>
  </b-card>
</template>

<script>

import ZClinic from '@/tools/clinic.vue'
import axios from '@/libs/axios'

export default {
  name: 'Invoice',
  components: { ZClinic },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        ClinicId: null,
      },
      showInvoiceModal: false,
      showConfirmModal: false,
      confirmRow: null,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Clinic',
          label: 'درمانگاه',
        },
        {
          key: 'Date',
          label: 'تاریخ',
        },
        {
          key: 'Price',
          label: 'جمع کل',
        },
        {
          key: 'Debt',
          label: 'مانده از قبل',
        },
        {
          key: 'TotalPrice',
          label: 'جمع نهایی',
        },
        {
          key: 'Balance',
          label: 'مانده حساب',
        },
        {
          key: 'IsConfirm',
          label: 'وضعیت',
        },
        {
          key: 'Description',
          label: 'توضیحات',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {},
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.invoice.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.invoice.add
      if (this.row.Id) {
        url = this.$api.invoice.update
      }

      this.$http.post(
        url, this.row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showInvoiceModal = true
        })
    },
    addInvoice() {
      this.row = {
        ClinicId: null, Description: null, Date: this.today(),
      }
      this.showInvoiceModal = true
    },
    remove(id) {
      this.removeRow(this.$api.invoice.remove, 'Id', id)
    },
    confirm(row) {
      this.confirmRow = row
      this.showConfirmModal = true
    },
    confirmInvoice() {
      this.$http.post(
        this.$api.invoice.confirm, { Id: this.confirmRow.Id },
      )
        .then(() => {
          this.update()
        })
        .finally(() => {
        })
    },
    today() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getBaseUrl(){
      return axios.defaults.baseURL.replace('/api/', '')
    }
  },
}
</script>
